import {CommonModule, registerLocaleData} from '@angular/common';
import localeSr from '@angular/common/locales/sr-Latn';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgModule, Injector} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';

import {MultiSelectModule} from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';

import {CurrencyMaskModule} from 'ng2-currency-mask';
import {
  AppValuePipe,
  AppDatePipe,
  ElementSearchTitleDirective,
  AppDropdownMenuComponent,
  SpinnerComponent,
  MessagesComponent,
  ModalWindowComponent,
  AppModalComponent,
  MessageModalComponent,
  AppTableComponent,
  AppMultiSelectComponent,
  TranslationEntityComponent,
  AuthenticationGuard,
  IsAuthenticatedGuard,
  TestService,
  UsersService,
  ApplicationActionsService,
  RolesService,
  TemplatesService,
  CurrenciesService,
  CompaniesService,
  InternalUsersService,
  AppHttpInterceptor,
  AppInjector,
  ValidatorRNDirective,
  OpnSupplierListService,
  SuppliersService,
  OpnSupplierListModel,
  SupplierRoundListService,
  SupplierOfferService,
  RequestItemsListViewService,
  RequestItemsLegalTermListService,
  SupplierOfferItemService,
  SupplierAuctionOfferService,
  SupplierAuctionRangListService,  ParameterTypesService, SupplierUserService, WidgetsService,
} from 'src/common';
import {
  ProcurementCategoriesService,
  TaskService,
  RequestsService,
  BudgetStatusesService,
  ProcurementModelsService,
  DocumentsService,
  AssessmentAreasService,
  OpnOfferEvaluationMethodsService,
  OpnTeamMembersService,
} from "src/common";

import {OrganizationalUnitService} from 'src/common/services/organizational-unit';
import {MainLayoutComponent} from 'src/layouts';
import {
  EmptyComponent,
  UnauthorizedComponent,
  TestComponent,
  TabsComponent,
  ElementsComponent,
  ElementComponent,
  ElementDateTimeComponent,
  ElementDocumentComponent,
  ElementFloatComponent,
  ElementIntegerComponent,
  ElementSingleSelectionComponent,
  ElementStringComponent,
  ElementTextComponent,
  CompanySelectComponent,
  ActionsInRoleComponent,
  ActionInRoleComponent,
  RolesComponent,
  RoleComponent,
  RoleCreateComponent,
  RoleEditComponent,
  RoleDetailsComponent,
  TemplateSelectComponent,
  UsersActiveEmployeesSelectComponent,
  LoginComponent,
  ForgetPasswordComponent,
  NewPasswordComponent,
  ChangePasswordComponent,
  InternalUsersComponent,
  InternalUserComponent,
  InternalUserEditComponent,
  InternalUserDetailsComponent,
  RolesSelectComponent,

  ProcurementCategorySelectComponent,
  RequestComponent,
  RequestEditComponent,
  RequestCreateComponent,
  RequestsComponent,
  RequestDetailsComponent,
  RequestOpnReviewComponent,
  RequestOpnConsentsComponent,
  RequestMessagesComponent,
  RequestBasicInformationComponent,
  OpnIntroductionComponent,
  OpnOfferEvaluationMethodComponent,
  OpnOfferEvaluationMethodsComponent,
  OpnOfferEvaluationMethodElementsComponent,
  OpnProjectDeadlineListComponent,
  OpnProjectDeadlinesListComponent,
  TaskSelectComponent,
  DocumentViewComponent,
  DocumentsComponent,
  OpnTeamMembersComponent,
  OpnTeamMemberComponent,
  OpnBoardMembersListComponent,
  OpnBoardMemberListComponent,
  SupplierSelectComponent, OpnSuppliersListComponent,
  SupplierRoundListSsy1190listComponent,
  SupplierOfferListSsy1200listComponent,
  RequestItemsListViewSsy1210listComponent,
  RequestItemsLegalTermListSsy1220listComponent,
  SupplierRoundListSsy1230detailComponent,
  SupplierRoundListSsy1230detailCreateComponent,
  SupplierRoundListSsy1230detailEditComponent,
  SupplierRoundListSsy1230detailDetailsComponent,

  SupplierOfferItemSsy1240listComponent, ParameterTypeComponent, SupplierOfferItemDetailComponent,
  SupplierOfferMessagesComponent,
  SupplierAuctionOfferListSsy1250listComponent,
  SupplierAuctionRangListSsy1260listComponent,
  SupplierAuctionOfferListSsy1280detailComponent,
  SupplierAuctionOfferListSsy1280detailCreateComponent,
  SupplierAuctionOfferListSsy1280detailEditComponent,
  SupplierAuctionOfferListSsy1280detailDetailsComponent,
  SupplierOfferDocumentsComponent,
  SupplierUserComponent,
  LogoutComponent,
  UndeliveredSupplierOffersWidgetComponent,
  InboxSupplierOffersWidgetComponent,
  HomePageComponent
// ${import}
} from 'src/views';
import {OrganizationalUnitSelectComponent} from 'src/views/components/organizational-unit-select';
import {RoleActionSelectComponent} from 'src/views/components/role-action-select';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {OpnBoardMembersListService} from "../common/services/requests/opn-steps/opn-boardmembers-list";
import {OpnProjectDeadlinesListService} from "../common/services/requests/opn-steps/opn-projectdeadlines-list";
import {UsageConditionsReviewComponent} from "../views/login/usage-conditions-review/usage-conditions-review.component";
import {RequestItemSelectComponent} from "../views/components/request-item-select";
import {CountdownTimerComponent} from "../common/components/timer/countdown-timer.component";
import { ConfirmedProcurementsComponent } from 'src/views/confirmed-procurements/confirmed-procurements.component';
import { InputFloatNumberDirective } from 'src/common/directives/input-float-numbers.directive';
import { InputIntegerNumberDirective } from 'src/common/directives/input-integer-numbers.directive';

registerLocaleData(localeSr, 'sr');

@NgModule({
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    MultiSelectModule,InputNumberModule,
    BrowserAnimationsModule,
    CurrencyMaskModule
  ],
  declarations: [
    /* -- Pipes -- */
    AppValuePipe,
    AppDatePipe,
    ElementSearchTitleDirective,
    /* -- Components -- */
    AppComponent,
    AppDropdownMenuComponent,
    SpinnerComponent,
    MessagesComponent,
    ModalWindowComponent,
    AppModalComponent,
    MessageModalComponent,
    AppTableComponent,
    AppMultiSelectComponent,

    /* -- Views -- */
    TranslationEntityComponent,
    EmptyComponent,
    MainLayoutComponent,
    UnauthorizedComponent,

    TestComponent,
    TabsComponent,

    ElementsComponent,
    ElementComponent,
    ElementDateTimeComponent,
    ElementDocumentComponent,
    ElementFloatComponent,
    ElementIntegerComponent,
    ElementSingleSelectionComponent,
    ElementStringComponent,
    ElementTextComponent,

    CompanySelectComponent,

    ActionsInRoleComponent,
    ActionInRoleComponent,
    RoleActionSelectComponent,

    RolesComponent,
    RoleComponent,
    RoleCreateComponent,
    RoleEditComponent,
    RoleDetailsComponent,

    TemplateSelectComponent,


    UsersActiveEmployeesSelectComponent,

    LoginComponent,
    ForgetPasswordComponent,
    NewPasswordComponent,
    ChangePasswordComponent,
    InternalUsersComponent,
    InternalUserComponent,
    InternalUserEditComponent,
    InternalUserDetailsComponent,
    RolesSelectComponent,
    OrganizationalUnitSelectComponent,

    ValidatorRNDirective,


    ProcurementCategorySelectComponent,


    RequestsComponent,
    RequestComponent,
    RequestCreateComponent,
    RequestEditComponent,
    RequestDetailsComponent,
    RequestOpnReviewComponent,
    RequestOpnConsentsComponent,

    RequestMessagesComponent,
    RequestBasicInformationComponent,
    DocumentsComponent,

    OpnIntroductionComponent,

    OpnOfferEvaluationMethodComponent,
    OpnOfferEvaluationMethodsComponent,
    OpnOfferEvaluationMethodElementsComponent,


    OpnBoardMembersListComponent,
    OpnBoardMemberListComponent,

    OpnTeamMembersComponent,
    OpnTeamMemberComponent,
    OpnSuppliersListComponent,
    UsersActiveEmployeesSelectComponent,

    DocumentViewComponent,

    OpnProjectDeadlineListComponent,
    OpnProjectDeadlinesListComponent,
    TaskSelectComponent,
    OrganizationalUnitSelectComponent,
    SupplierSelectComponent,
    SupplierRoundListSsy1190listComponent,
    SupplierOfferListSsy1200listComponent,
    RequestItemsListViewSsy1210listComponent,
    RequestItemsLegalTermListSsy1220listComponent,
    SupplierRoundListSsy1230detailComponent,
    SupplierRoundListSsy1230detailCreateComponent,
    SupplierRoundListSsy1230detailEditComponent,
    SupplierRoundListSsy1230detailDetailsComponent,
    SupplierOfferItemDetailComponent,
    ParameterTypeComponent,
    SupplierOfferItemSsy1240listComponent,
    UsageConditionsReviewComponent,
    RequestItemSelectComponent,
    SupplierOfferMessagesComponent,
    SupplierAuctionOfferListSsy1250listComponent,
    SupplierAuctionRangListSsy1260listComponent,
    SupplierAuctionOfferListSsy1280detailComponent,
    SupplierAuctionOfferListSsy1280detailCreateComponent,
    SupplierAuctionOfferListSsy1280detailEditComponent,
    SupplierAuctionOfferListSsy1280detailDetailsComponent,
    CountdownTimerComponent,
    SupplierOfferDocumentsComponent,

    InputIntegerNumberDirective,
    InputFloatNumberDirective,

    ConfirmedProcurementsComponent,
    SupplierUserComponent,
    LogoutComponent,

    HomePageComponent,
    UndeliveredSupplierOffersWidgetComponent,
    InboxSupplierOffersWidgetComponent,
// ${declaration}
  ],
  providers: [
    AuthenticationGuard,
    IsAuthenticatedGuard,
    TestService,
    UsersService,
    ApplicationActionsService,
    RolesService,
    TemplatesService,
    CurrenciesService,
    CompaniesService,
    InternalUsersService,
    OrganizationalUnitService,


    ProcurementCategoriesService,
    TaskService,
    RequestsService,
    BudgetStatusesService,
    CurrenciesService,
    CompaniesService,
    ProcurementModelsService,
    DocumentsService,
    AssessmentAreasService,
    OpnOfferEvaluationMethodsService,
    OpnTeamMembersService,
    InternalUsersService,
    OpnSupplierListService,
    OpnBoardMembersListService,
    OpnProjectDeadlinesListService,
    SuppliersService,
    SupplierRoundListService,
    SupplierOfferService,
    RequestItemsListViewService,
    RequestItemsLegalTermListService,
    SupplierOfferItemService,
    SupplierAuctionOfferService,
    SupplierAuctionRangListService,
    ParameterTypesService,
    SupplierUserService,

    WidgetsService,

    {provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector.instance = this.injector;
  }
}
